import { render } from "./UserPermissionSet.vue?vue&type=template&id=fc8d241a&scoped=true"
import script from "./UserPermissionSet.vue?vue&type=script&lang=js"
export * from "./UserPermissionSet.vue?vue&type=script&lang=js"

import "./UserPermissionSet.vue?vue&type=style&index=0&id=fc8d241a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8d241a"]])

export default __exports__